export const MODULE_TO_DETAIL = [
  { module: 'API', detail: '/ocr-detail' },
  { module: 'OCR', detail: '/ocr-detail' },
  { module: 'DIFF', detail: '/diff-detail' },
  { module: 'SCENE', detail: '/cross/task-setting' },
  { module: 'CORRECT', detail: '/correct-detail' },
  { module: 'TABLE', detail: '/recognition-detail' },
];
